import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { PerformanceDashboard, QuantitativeMetric } from '../../types/dashboard.types';

export interface HealthStripProps {
  dashboard: PerformanceDashboard;
}

export const HealthStrip = ({ dashboard }: HealthStripProps) => {
  const { t } = useTranslation();

  let metrics: QuantitativeMetric[] = [];
  try {
    metrics = JSON.parse(dashboard.QuantitativeMetricsJson) as QuantitativeMetric[];
  } catch {
    metrics = [];
  }

  const worstAchievement = metrics.length
    ? Math.min(...metrics.map((metric) => metric.AchievementPercent))
    : 100;
  const status =
    worstAchievement >= 100 ? 'success' : worstAchievement >= 75 ? 'warning' : 'error';

  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-between gap-x-4 gap-y-1 rounded-md border-l-4 bg-surface px-4 py-3 text-sm',
        status === 'success' && 'border-l-success',
        status === 'warning' && 'border-l-warning',
        status === 'error' && 'border-l-error'
      )}
    >
      <span>{t('PORTFOLIO_HEALTH')}</span>
      <span className="font-medium">{worstAchievement.toFixed(0)}% {t('MIN_ACHIEVEMENT')}</span>
    </div>
  );
};
